import React from 'react';
import { wine } from '../../models/wine';
import { Divider } from '@mui/material';

export interface WineElementProps {
    wine: wine
}
function WineElement(props: WineElementProps) {
    return (
        <div className='mt-2'>


            <div className='wine-title text-start mt-2'>
                {props.wine.nome}
            </div>
            <div className='flex-between'>

                <div className='wine-desciption'>
                    {props.wine.cantina}
                </div>
                <div className='wine-desciption'>
                    {props.wine.annata} {props.wine.vol}%
                </div>
            </div>

            <div className='flex-center-end mt-2'>
                {
                    props.wine.chalicePrice > 0 ?
                        <div className='flex-start-end'>
                            <div className='dish-price'>
                                <img className='wine-chalice-price-icon' src={process.env.PUBLIC_URL + '/icons/wine-chalice.png'} />
                            </div>
                            <div className='dish-price mr-2 ml-1'>{props.wine.chalicePrice}€</div>
                        </div> : <></>
                }

                <div className='flex-start-end'>
                    <div className='dish-price'>
                        <img className='wine-price-icon ' src={process.env.PUBLIC_URL + '/icons/wine-bottle.png'} />
                    </div>
                    <div className='dish-price ml-1'>{props.wine.bottlePrice}€</div>
                </div>
            </div>

            <Divider className='inset-divider mt-1 mb-3' />

            {/* <div className='flex-start-center'>

                <div className='dish-description '>
                    {props.element.descrizione}
                </div>
            </div> */}
        </div>
    );
}

export default WineElement;